import React from "react";
import { useNavigate } from "react-router";

import { postAdminRemoveFrontendAddon } from "@/api/admin/frontendAddons";
import { postRemoveFrontendAddon } from "@/api/frontendAddons";
import { useAppAccount } from "@/components/AppProvider/AppAccountProvider";
import { FrontendAddonRaw } from "@/domain/FrontendAddon";
import { useAppRouteParams } from "../../../../../AppRoutes";
import { getDialogMessages } from "../../../DialogFirestore/helper";
import { DialogPhaseStatesType, useDialog } from "../../../helpers/hooks";

import { useAppNotificationManager } from "@/components/AppProvider/AppNotificationProvider";

export const DialogFrontendAddonRemove: React.FC<
  {
    frontendAddons: FrontendAddonRaw[];
    selectedFrontendAddonIds: string[];
    setSelectedFrontendAddonIds: React.Dispatch<React.SetStateAction<string[]>>;
    runReloadFrontendAddons: () => Promise<void>;
    returnPath: string;
  } & DialogPhaseStatesType
> = ({
  frontendAddons,
  selectedFrontendAddonIds,
  setSelectedFrontendAddonIds,
  dialogPhase,
  setDialogPhase,
  runReloadFrontendAddons,
  returnPath,
}) => {
  const { organizationId } = useAppRouteParams();
  const { isAADeveloperOrAbove } = useAppAccount();
  const navigate = useNavigate();

  const versionName =
    frontendAddons.find(({ id }) => selectedFrontendAddonIds?.[0] === id)
      ?.name || "";

  const { renderDialogs } = useDialog({
    dialogPhase,
    setDialogPhase,
  });

  const { showSuccessNotification, showErrorNotification } =
    useAppNotificationManager();

  const messages = getDialogMessages({
    isSome: false,
    actionType: "delete",
    targetType: "frontendAddon",
    targetName: versionName || undefined,
  });

  const runRemove = async () => {
    setDialogPhase("in_progress");
    try {
      isAADeveloperOrAbove
        ? await postAdminRemoveFrontendAddon({
            frontendAddonId: selectedFrontendAddonIds[0],
          })
        : await postRemoveFrontendAddon({
            organizationId,
            frontendAddonId: selectedFrontendAddonIds[0],
          });
      setSelectedFrontendAddonIds([]);
      await runReloadFrontendAddons();
      showSuccessNotification(messages.success.displayMessage);
      navigate(returnPath);
    } catch (error) {
      showErrorNotification(messages.error.displayMessage, error);
    }
    setDialogPhase(null);
  };

  return (
    <>
      {renderDialogs({
        confirm: {
          ...messages.confirm,
          onClick: runRemove,
          onClickCancel: () => {
            setSelectedFrontendAddonIds([]);
          },
          isThemeRed: true,
        },
        inProgress: { ...messages.inProgress },
      })}
    </>
  );
};
